module.exports = __webpack_public_path__ + "img/drone_02_H.a0c98bab.webp";